"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721MintByIDClient = void 0;
const ImmutableERC721MintByID__factory_1 = require("../typechain-types/factories/contracts/token/erc721/preset/ImmutableERC721MintByID__factory");
const overrides_1 = require("./config/overrides");
/**
 * @deprecated ERC721MintByIDClient is deprecated and will be removed in the future. Please refer to
 * our latest guides for recommendations on interacting with deployed preset contracts:
 * https://docs.immutable.com/docs/zkEVM/deploy-contracts/interact
 */
class ERC721MintByIDClient {
    constructor(contractAddress) {
        const factory = new ImmutableERC721MintByID__factory_1.ImmutableERC721MintByID__factory();
        this.contract = factory.attach(contractAddress);
    }
    /**
     * Read functions
     */
    /**
     * @returns the DEFAULT_ADMIN_ROLE as a string.
     */
    async DEFAULT_ADMIN_ROLE(provider, overrides = {}) {
        return await this.contract.connect(provider).DEFAULT_ADMIN_ROLE(overrides);
    }
    /**
     * @returns the MINTER_ROLE as a string.
     */
    async MINTER_ROLE(provider, overrides = {}) {
        return await this.contract.connect(provider).MINTER_ROLE(overrides);
    }
    /**
     * @returns the balance of an address as a BigNumber.
     */
    async balanceOf(provider, owner, overrides = {}) {
        return await this.contract.connect(provider).balanceOf(owner, overrides);
    }
    /**
     * @returns the baseURI as a string.
     */
    async baseURI(provider, overrides = {}) {
        return await this.contract.connect(provider).baseURI(overrides);
    }
    /**
     * @returns the contractURI as a string.
     */
    async contractURI(provider, overrides = {}) {
        return await this.contract.connect(provider).contractURI(overrides);
    }
    /**
     * @returns admin addresses as an array of strings.
     */
    async getAdmins(provider, overrides = {}) {
        return await this.contract.connect(provider).getAdmins(overrides);
    }
    /**
     * @returns the approved address for a token ID, or zero if no address set.
     */
    async getApproved(provider, tokenId, overrides = {}) {
        return await this.contract.connect(provider).getApproved(tokenId, overrides);
    }
    /**
     * @returns the role admin address.
     */
    async getRoleAdmin(provider, role, overrides = {}) {
        return await this.contract.connect(provider).getRoleAdmin(role, overrides);
    }
    /**
     * @returns the role member address at a particular index.
     */
    async getRoleMember(provider, role, index, overrides = {}) {
        return await this.contract.connect(provider).getRoleMember(role, index, overrides);
    }
    /**
     * @returns the role member count as a BigNumber.
     */
    async getRoleMemberCount(provider, role, overrides = {}) {
        return await this.contract.connect(provider).getRoleMemberCount(role, overrides);
    }
    /**
     * @returns a boolean for whether an account has a particular role.
     */
    async hasRole(provider, role, account, overrides = {}) {
        return await this.contract.connect(provider).hasRole(role, account, overrides);
    }
    /**
     * @returns a boolean that tells whether an operator is approved by a given owner.
     */
    async isApprovedForAll(provider, owner, operator, overrides = {}) {
        return await this.contract.connect(provider).isApprovedForAll(owner, operator, overrides);
    }
    /**
     * @returns the name of the contract as a string.
     */
    async name(provider, overrides = {}) {
        return await this.contract.connect(provider).name(overrides);
    }
    /**
     * @returns the owner address of a particular tokenId.
     */
    async ownerOf(provider, tokenId, overrides = {}) {
        return await this.contract.connect(provider).ownerOf(tokenId, overrides);
    }
    /**
     * Returns the current nonce of a given token ID.
     * @param tokenId The ID of the token for which to retrieve the nonce.
     * @return Current nonce of the given token.
     */
    async nonces(provider, tokenId, overrides = {}) {
        return await this.contract.connect(provider).nonces(tokenId, overrides);
    }
    /**
     * @returns the operator allowlist as a string.
     */
    async operatorAllowlist(provider, overrides = {}) {
        return await this.contract.connect(provider).operatorAllowlist(overrides);
    }
    /**
     * @returns the royalty information for a particular tokenId.
     */
    async royaltyInfo(provider, _tokenId, _salePrice, overrides = {}) {
        return await this.contract.connect(provider).royaltyInfo(_tokenId, _salePrice, overrides);
    }
    /**
     * @returns the symbol of the contract as a string.
     */
    async symbol(provider, overrides = {}) {
        return await this.contract.connect(provider).symbol(overrides);
    }
    /**
     * @returns the Uniform Resource Identifier (URI) for tokenId token.
     */
    async tokenURI(provider, tokenId, overrides = {}) {
        return await this.contract.connect(provider).tokenURI(tokenId, overrides);
    }
    /**
     * @returns returns the total amount of tokens stored by the contract.
     */
    async totalSupply(provider, overrides = {}) {
        return await this.contract.connect(provider).totalSupply(overrides);
    }
    /**
     * Write functions
     */
    /**
     * @returns a populated transaction for the approve contract function
     */
    async populateApprove(to, tokenId, overrides = {}) {
        return await this.contract.populateTransaction.approve(to, tokenId, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * Function to approve by way of owner signature
     * @param spender the address to approve
     * @param tokenId the index of the NFT to approve the spender on
     * @param deadline a timestamp expiry for the permit
     * @param sig a traditional or EIP-2098 signature
     */
    async populatePermit(spender, tokenId, deadline, sig, overrides = {}) {
        return await this.contract.populateTransaction.permit(spender, tokenId, deadline, sig, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the burn contract function
     */
    async populateBurn(tokenId, overrides = {}) {
        return await this.contract.populateTransaction.burn(tokenId, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the batch burn contract function
     */
    async populateBurnBatch(tokenIds, overrides = {}) {
        return await this.contract.populateTransaction.burnBatch(tokenIds, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the grantMinterRole contract function
     */
    async populateGrantMinterRole(user, overrides = {}) {
        return await this.contract.populateTransaction.grantMinterRole(user, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the grantRole contract function
     */
    async populateGrantRole(role, account, overrides = {}) {
        return await this.contract.populateTransaction.grantRole(role, account, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the mint contract function
     */
    async populateMint(to, tokenId, overrides = {}) {
        return await this.contract.populateTransaction.mint(to, tokenId, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the batch mint contract function
     */
    async populateSafeMintBatch(mints, overrides = {}) {
        return await this.contract.populateTransaction.safeMintBatch(mints, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the safe burn contract function
     */
    async populateSafeBurn(owner, tokenId, overrides = {}) {
        return await this.contract.populateTransaction.safeBurn(owner, tokenId, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the safe burn batch contract function
     */
    async populateSafeBurnBatch(burns, overrides = {}) {
        return await this.contract.populateTransaction.safeBurnBatch(burns, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the renounceRole contract function
     */
    async populateRenounceRole(role, account, overrides = {}) {
        return await this.contract.populateTransaction.renounceRole(role, account, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the revokeMinterRole contract function
     */
    async populateRevokeMinterRole(user, overrides = {}) {
        return await this.contract.populateTransaction.revokeMinterRole(user, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the revokeRole contract function
     */
    async populateRevokeRole(role, account, overrides = {}) {
        return await this.contract.populateTransaction.revokeRole(role, account, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the batch save transfer from function
     */
    async populateSafeTransferFromBatch(transfers, overrides = {}) {
        return await this.contract.populateTransaction.safeTransferFromBatch(transfers, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the safeTransferFrom(address,address,uint256) contract function
     */
    async "populateSafeTransferFrom(address,address,uint256)"(from, to, tokenId, overrides = {}) {
        return await this.contract.populateTransaction["safeTransferFrom(address,address,uint256)"](from, to, tokenId, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the safeTransferFrom(address,address,uint256,bytes) contract function
     */
    async "populateSafeTransferFrom(address,address,uint256,bytes)"(from, to, tokenId, data, overrides = {}) {
        return await this.contract.populateTransaction["safeTransferFrom(address,address,uint256,bytes)"](from, to, tokenId, data, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the setApprovalForAll contract function
     */
    async populateSetApprovalForAll(operator, approved, overrides = {}) {
        return await this.contract.populateTransaction.setApprovalForAll(operator, approved, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the setBaseURI contract function
     */
    async populateSetBaseURI(baseURI_, overrides = {}) {
        return await this.contract.populateTransaction.setBaseURI(baseURI_, { ...overrides_1.defaultGasOverrides, ...overrides });
    }
    /**
     * @returns a populated transaction for the setContractURI contract function
     */
    async populateSetContractURI(_contractURI, overrides = {}) {
        return await this.contract.populateTransaction.setContractURI(_contractURI, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the setDefaultRoyaltyReceiver contract function
     */
    async populateSetDefaultRoyaltyReceiver(receiver, feeNumerator, overrides = {}) {
        return await this.contract.populateTransaction.setDefaultRoyaltyReceiver(receiver, feeNumerator, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the setNFTRoyaltyReceiver contract function
     */
    async populateSetNFTRoyaltyReceiver(tokenId, receiver, feeNumerator, overrides = {}) {
        return await this.contract.populateTransaction.setNFTRoyaltyReceiver(tokenId, receiver, feeNumerator, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
    /**
     * @returns a populated transaction for the setNFTRoyaltyReceiverBatch contract function
     */
    async populateSetNFTRoyaltyReceiverBatch(tokenIds, receiver, feeNumerator, overrides = {}) {
        return await this.contract.populateTransaction.setNFTRoyaltyReceiverBatch(tokenIds, receiver, feeNumerator, {
            ...overrides_1.defaultGasOverrides,
            ...overrides,
        });
    }
}
exports.ERC721MintByIDClient = ERC721MintByIDClient;
